import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=0cf822f6&scoped=true&"
import script from "./IndexPage.vue?vue&type=script&lang=js&"
export * from "./IndexPage.vue?vue&type=script&lang=js&"
import style0 from "./IndexPage.vue?vue&type=style&index=0&id=0cf822f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf822f6",
  null
  
)

export default component.exports